import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <section className="bg-ice px-4 py-16 md:px-8 md:py-24" data-id="element-304" data-mp="3mh2adt3b3cf2">
      <div className="mx-auto max-w-6xl" data-id="element-305" data-mp="3mepjurjhftqe">
        <h2 className="mx-auto max-w-3xl text-center font-display text-[26px] font-black leading-tight text-navy sm:text-4xl" data-id="element-306" data-mp="3r80vd5z8oyon">
          What Dental Professionals Value About This Collection
        </h2>

        <ul className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-307" data-mp="421i2vhw2ed0">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-sm ring-1 ring-ice-line" data-id="element-308" data-mp="92xkf4mldsgb">
              <div className="flex items-center gap-4" data-id="element-309" data-mp="dzo2fxhyiy4d">
                <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-ice" loading="lazy" data-id="element-310" data-mp="2atiskfj87wki" />
                <div data-id="element-311" data-mp="2ft566q2yvetu">
                  <p className="font-display text-[16px] font-extrabold text-ink" data-id="element-312" data-mp="2fsluvs7tnoos">{t.name}</p>
                  <p className="text-sm text-ink-muted" data-id="element-313" data-mp="1slu5y6flvx9f">{t.role}</p>
                  <div className="mt-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-314" data-mp="1nsrlqowpy05w">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-315" data-mp="1isdc52fgyi5r" data-mpi={i} />)}
                  </div>
                </div>
              </div>
              <blockquote className="mt-5 flex-1 text-[15px] leading-relaxed text-ink" data-id="element-316" data-mp="2bhaut6nlegz1">“{t.quote}”</blockquote>
            </li>)}
        </ul>

        <SectionCta label="Get My Clinical Collection — $27" data-id="element-317" data-mp="22hxkkbrn9od9" />
      </div>
    </section>;
}